import { BASE_API_URL } from "@/configs/env.config";
import axios from "axios";

export async function refreshAccessToken(refreshToken: string) {
  try {
    const response = await axios.post(
      "/user/authen/refresh",
      {
        refresh_token: refreshToken,
      },
      {
        baseURL: BASE_API_URL,
      }
    );
    if (response.status === 200 && response.data) {
      return response?.data?.result;
    }
    return null;
  } catch (error) {
    return null;
  }
}
